import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent }    from './login/login.component';
import { SignupComponent }   from './signup/signup.component';
import { ConfirmComponent }  from './confirm/confirm.component';
import { HomeComponent }     from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ChooseAppComponent } from './choose-app/choose-app.component';
import { FacegateSubscriptionComponent } from './facegate-subscription/facegate-subscription.component';
import { FacegatePhotosComponent } from './facegate-photos/facegate-photos.component';
import { FacegateReportsComponent } from './facegate-reports/facegate-reports.component';
import { FacegatePaymentErrorComponent } from './facegate-payment-error/facegate-payment-error.component';
import { FacegatePaymentSuccessComponent } from './facegate-payment-success/facegate-payment-success.component';
import { FacegateReportConfigComponent } from './facegate-report-config/facegate-report-config.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';


import { AuthGuard } from './auth.guard';

const routes: Routes = [

      // first version

      // the address / (empty path) is redirected to /home
      { path: '', redirectTo: 'chooseapp', pathMatch: 'full' },

      // the home path is guarded, so the unauthenticated user is redirected
      // to login and the authenticated user is allowed to access (the home page)
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'chooseapp', component: ChooseAppComponent, canActivate: [AuthGuard] },
      { path: 'payFacegate', component: FacegateSubscriptionComponent, canActivate: [AuthGuard] },
      { path: 'photosFacegate', component: FacegatePhotosComponent, canActivate: [AuthGuard] },
      { path: 'reportsFacegate', component: FacegateReportsComponent, canActivate: [AuthGuard] },
      { path: 'paymentError', component: FacegatePaymentErrorComponent, canActivate: [AuthGuard] },
      { path: 'paymentSuccess', component: FacegatePaymentSuccessComponent, canActivate: [AuthGuard] },
      { path: 'reportConfig', component: FacegateReportConfigComponent, canActivate: [AuthGuard] },
      { path: 'changePassword', component: ChangePasswordComponent, canActivate: [AuthGuard] },
      { path: 'forgotPassword', component: ForgotPasswordComponent },


      { path: 'login',   component: LoginComponent },
      { path: 'signup',  component: SignupComponent },
      { path: 'confirm', component: ConfirmComponent },

      // any other path leads to the NotFoundComponent
      { path: '**', component: NotFoundComponent }

];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  providers : [ AuthGuard]
})
export class AppRoutingModule {}
